import { AfterViewInit, ChangeDetectorRef, Component, OnInit, QueryList, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatListOption, MatSelectionList, MatSelectionListChange } from '@angular/material/list';
import { Observable } from 'rxjs';
import { HTTPService } from 'src/app/services/http.service';
import * as fileSaver from 'file-saver';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { DatePipe } from '@angular/common';
import { tap } from 'rxjs/operators';

export interface file{
   filename:string,
   size:number,
   lastchange:string
}

@Component({
    selector: 'log-aplicacao',
    templateUrl: './log-aplicacao.component.html',
    styleUrls: ['./log-aplicacao.component.scss'],
    standalone: false
})


export class LogAplicacaoComponent implements OnInit, AfterViewInit {

  time = 1;
  atualizacao:String;
  interval: NodeJS.Timeout;

  constructor(private http:HTTPService, private snackBar:SnackbarService,public datepipe: DatePipe, private cd:ChangeDetectorRef) { 

      this.interval = setInterval(()=>{
          this.refresh();
          this.cd.markForCheck();
      },this.time*1000*60)

  }
  
  ngAfterViewInit(): void {
    
    this.files.selectionChange.subscribe((selection:MatSelectionListChange)=>{
      selection.options.forEach((op:MatListOption)=>{
          if ( op.selected ) {
            this.selectedFiles.push(op.value);  
          }else{
            this.selectedFiles.splice(this.selectedFiles.indexOf(op.value),1);
          }
          
      })
      
    });
  }

  
  @ViewChild('files',{read:MatSelectionList}) files:MatSelectionList;
  
  listOfFiles:Observable<file[]> = new Observable();
  selectedFiles:file[] = [];
  
  mensagens:Object[] = [];

  ngOnInit(): void {
      this.loadFiles();
  }

  ngOnDestroy(){
    clearInterval(this.interval);
  }

  loadFiles(){
      this.listOfFiles = this.http.postGeneric<file[]>({}, "ExceptionServices/getFilesError",false,true);
      this.atualizacao = this.datepipe.transform(new Date(), 'dd/MM/yyyy HH:mm:ss'); 
      this.listOfFiles = this.listOfFiles.pipe(tap(x=>{
        if ( x!= null ){
          x.sort((a:file,b:file)=>{
          
            if (a.size > b.size  ) return -1;
            if (a.size < b.size  ) return 1;
            return 0;
          });
        }
        
      }))
  }

  download(){
    
    this.selectedFiles.forEach(file=>{
      this.downloadFile(file.filename);
    })
    
    
  }

  downloadFile(filename: string) {

    this.http.downloadFile(`ExceptionServices/${filename}/text`).subscribe(data=>{
      const blob = data;
      fileSaver.saveAs(blob, filename);

    });
  }

  viewFile(){
    
    if ( this.selectedFiles.length > 1 ){
      this.snackBar.showError('Para visualizar, selecionar apenas um arquivo.');
    }

    if ( this.selectedFiles.length == 0 ){
      return;
    }

    let file = this.selectedFiles[0];
    let thread = file.filename.match('(?<=_)[^\._\r\n]*(?=\.)')[0]

    let ob = {
        thread: thread
    }

    this.http.post(ob,'ExceptionServices/getError',false,true).subscribe(data=>{
          this.mensagens = [...data as Object[]];
    })
  }

  
  refresh(){
    this.loadFiles();
  }
}
